import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import PageContainer from '../../../components/layout/page-container/PageContainer';
import withRouter from '../../../hoc/with-router';
import { useLazyGetExerciseById } from '../../../redux/api/exercisesAPI';
import NewExerciseForm from './NewExerciseForm';

function NewExercise(props) {
  const { params } = props;
  const { t } = useTranslation();

  const isEditableExercise = !!params.exerciseId;
  const [getExercise, { data: getExerciseResponse }] = useLazyGetExerciseById();

  const exercise = getExerciseResponse?.exercise;

  useEffect(() => {
    if (params.exerciseId) {
      getExercise({ id: params.exerciseId });
    }
  }, [params.exerciseId, getExercise]);

  return (
    <PageContainer
      title={isEditableExercise ? exercise?.title : t('exercises.newExercise')}
      backButton>
      <NewExerciseForm exerciseId={params.exerciseId} />
    </PageContainer>
  );
}

export default withRouter(NewExercise);
